import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { isFunction } from '#lib/utils/function.js';
import toast from 'react-hot-toast';

async function getInfo(body, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/flightInfo`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });

    return response;
}

async function updateFlightInfo(body, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/flightInfo`, {
        method: 'PUT',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });

    return response;
}

export default function useFlights({ onCreate, onUpdate, cancelLoading }) {
    const retrieveFlightInfo = useAuthMutation({
        mutationFn: getInfo,
        mutationKey: ['flights'],
        onSuccess: (res) => {
            if (res.ok) {
                if (!res.data || !res.data.flightKey) toast.error(_t.global.noFlightData());
                else toast.success(_t.global.success());
                if (isFunction(onCreate)) onCreate(res.data);
            } else toast.error(_t.global.error());
            if (isFunction(cancelLoading)) cancelLoading();
        },
        onError: (e) => {
            toast.error(e.message);
            if (isFunction(cancelLoading)) cancelLoading();
        }
    });

    const updateFlight = useAuthMutation({
        mutationFn: updateFlightInfo,
        mutationKey: ['flights'],
        onSuccess: (res) => {
            if (res.ok) {
                if (isFunction(onUpdate)) onUpdate(res.data);
                toast.success(_t.global.success());
            } else toast.error(_t.global.error());
        },
        onError: (e) => {
            toast.error(e.message);
        }
    });

    return { retrieveFlightInfo, updateFlight };
}
